import { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import StoreStyle from '../../../assets/stylesheets/store/StorePage.module.css';
import StoreCardList from "../StoreCardList";

import ButternutSquash from '../../../assets/img/sample/Butternut Squash.jpg';
import AcornSquash from '../../../assets/img/sample/Acorn Squash.jpg';
import Pumpkin from '../../../assets/img/sample/Sugar Pie Pumpkin.jpg';
import Leeks from '../../../assets/img/sample/Leeks.jpg';
import Grapes from '../../../assets/img/sample/Concord Grapes.jpg';
import Beets from '../../../assets/img/sample/Chioggia Beets.jpg';

const SEASONAL_ITEMS = [
  { id: 'sea-1', name: 'Butternut Squash',    price: '$1.49/lb',      info: 'Sweet & nutty • Roasts beautifully', img: ButternutSquash },
  { id: 'sea-2', name: 'Acorn Squash',        price: '$1.29/lb',      info: 'Tender flesh • Great for stuffing',   img: AcornSquash },
  { id: 'sea-3', name: 'Sugar Pie Pumpkin',   price: '$3.99/ea',      info: 'Perfect for pies • Small & sweet',    img: Pumpkin },
  { id: 'sea-4', name: 'Leeks',               price: '$2.49/bunch',   info: 'Mild & aromatic • Ideal for soups',   img: Leeks },
  { id: 'sea-5', name: 'Concord Grapes',      price: '$3.49/lb',      info: 'Richly aromatic • Jelly favorite',    img: Grapes },
  { id: 'sea-6', name: 'Chioggia Beets',      price: '$2.49/bunch',   info: 'Candy-striped • Sweet & crisp',       img: Beets },
];

export default function SeasonalItems({ title = 'Seasonal picks', to }) {
    const LIMIT = 6;
    const [loading, setLoading] = useState(true);
  
    // simulate async loading for demo purposes
    useEffect(() => {
      const t = setTimeout(() => setLoading(false), 300);
      return () => clearTimeout(t);
    }, []);
  
    return (
      <section className={StoreStyle['featured-section']}>
        <div className={StoreStyle['featured-header']}>
          <h2 style={{ fontSize: 22, margin: 0 }}>{title}</h2>
          {to ? <Link to={to} style={{ color: '#16a34a', fontWeight: 600 }}>See all</Link> : null}
        </div>
  
        {/* Simple wrapper without external arrows */}
        <div className={StoreStyle['swiper-rail']}>
          <StoreCardList
            items={SEASONAL_ITEMS}
            loading={loading}
            onBuy={(item) => {
              // placeholder action for demo
              // eslint-disable-next-line no-console
              console.log('Buy clicked:', item);
            }}
            skeletonCount={LIMIT}
          />
        </div>
      </section>
    );
}
